import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, Star } from "lucide-react";

const BOOKING_URL = "/book";

const PricingPackages = () => {
  const packages = [
    {
      name: "The Reset Package",
      price: "$497",
      popular: true,
      tagline: "Most popular — perfect for 1 problem area",
      features: [
        "4 hours of hands-on organizing",
        "2 zones (e.g. pantry + command center)",
        "Basic containers & labels included",
        "Donation removal included",
        "30-day follow-up check-in",
      ],
    },
    {
      name: "The Fresh Start Package",
      price: "$997",
      popular: false,
      tagline: "For bigger projects or new life phases",
      features: [
        "2 full days (12 hours total)",
        "Whole room or multiple zones",
        "Custom product shopping list",
        "Sustainable donation & recycling plan",
        "60-day support check-ins",
      ],
    },
  ];

  return (
    <section id="pricing" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <header className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-serif font-light mb-4">
            Flat-Rate Packages
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Transparent pricing, no hidden fees. Choose the package that fits your space and goals.
          </p>
        </header>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {packages.map((pkg) => (
            <Card
              key={pkg.name}
              className={`relative border-border hover-lift fade-in-up flex flex-col ${
                pkg.popular ? "border-primary/40 shadow-lg ring-1 ring-primary/20" : ""
              }`}
            >
              {pkg.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-primary-foreground text-xs font-semibold px-4 py-1 rounded-full flex items-center gap-1">
                  <Star className="w-3 h-3 fill-current" />
                  Most Popular
                </div>
              )}
              <CardHeader className="text-center pb-2 pt-8">
                <CardTitle className="text-xl font-serif">{pkg.name}</CardTitle>
                <div className="text-4xl font-serif font-light text-primary mt-2">{pkg.price}</div>
                <p className="text-sm text-muted-foreground mt-2 italic">{pkg.tagline}</p>
              </CardHeader>
              <CardContent className="space-y-4 flex-1 flex flex-col">
                <ul className="space-y-2.5 flex-1">
                  {pkg.features.map((f, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <Check className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                      <span className="text-sm">{f}</span>
                    </li>
                  ))}
                </ul>
                <Button
                  onClick={() => window.location.href = BOOKING_URL}
                  size="lg"
                  className={`w-full mt-auto ${pkg.popular ? "luxury-gradient text-primary-foreground" : ""}`}
                  variant={pkg.popular ? "default" : "outline"}
                >
                  Book {pkg.name.replace("The ", "")}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        <p className="text-center text-sm text-muted-foreground mt-8">
          Not sure which package? <button onClick={() => window.location.href = BOOKING_URL} className="text-primary underline underline-offset-2 hover:text-primary/80">Book a free 20-min video call</button> and we'll help you decide.
        </p>
      </div>
    </section>
  );
};

export default PricingPackages;
